import * as types from "./actionType";

const initialState = {
  branchStatus: false,
  branches: [],
  branchCount: 0,
  countryStatus: false,
  countries: [],
  stateStatus: false,
  states: [],
  cityStatus: false,
  cities: [],
  updateBranchStatus: false,
  branchSingleDataStatus: false,
  branchData: null,
  branchUserDataStatus: false,
  branchUserData: null,
  countryBranchStatus: false,
  countriesBranch: [],
  stateBranchStatus: false,
  statesBranch: [],
  cityBranchStatus: false,
  citiesBranch: [],
  deleteBranchStatus: false,
  creatingTestimonialStatus: false,
  appliedBranchStatus: false,
  appliedBranch: [],
  createAppliedBranchStatus: false,
  updateAppliedBranchStatus: false,
  moderationStatus: false,
  dealerProfileStatus: false,
  updateButtonClickPlace: "",
  dealerProfile: null,
};

function branchReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_ALL_BRANCH:
      return {
        ...state,
        branchStatus: true,
      };
    case types.FETCH_ALL_BRANCH_SUCCESS: {
      return {
        ...state,
        branchStatus: false,
        branches: [...state.branches, ...action.payload],
        branchCount: action.count,
      };
    }
    case types.FETCH_ALL_BRANCH_FAILED: {
      return {
        ...state,
        branchStatus: false,
        branches: [],
      };
    }

    case types.FETCH_COUNTRY:
      return {
        ...state,
        countryStatus: true,
        countries: [],
      };
    case types.FETCH_COUNTRY_SUCCESS: {
      return {
        ...state,
        countryStatus: false,
        countries: action.payload,
      };
    }
    case types.FETCH_COUNTRY_FAILED: {
      return {
        ...state,
        countryStatus: false,
        countries: [],
      };
    }

    case types.FETCH_STATE:
      return {
        ...state,
        stateStatus: true,
        states: [],
      };
    case types.FETCH_STATE_SUCCESS: {
      return {
        ...state,
        stateStatus: false,
        states: action.payload,
      };
    }
    case types.FETCH_STATE_FAILED: {
      return {
        ...state,
        stateStatus: false,
        states: [],
      };
    }

    case types.FETCH_CITY:
      return {
        ...state,
        cityStatus: true,
        cities: [],
      };
    case types.FETCH_CITY_SUCCESS: {
      return {
        ...state,
        cityStatus: false,
        cities: action.payload,
      };
    }
    case types.FETCH_CITY_FAILED: {
      return {
        ...state,
        cityStatus: false,
        cities: [],
      };
    }

    case types.UPDATE_BRANCH:
      return {
        ...state,
        updateBranchStatus: true,
      };
    case types.UPDATE_BRANCH_SUCCESS: {
      return {
        ...state,
        updateBranchStatus: false,
      };
    }
    case types.UPDATE_BRANCH_FAILED: {
      return {
        ...state,
        updateBranchStatus: false,
      };
    }

    case types.FETCH_SINGLE_BRANCH:
      return {
        ...state,
        branchSingleDataStatus: true,
        branchData: null,
      };
    case types.FETCH_SINGLE_BRANCH_SUCCESS: {
      return {
        ...state,
        branchSingleDataStatus: false,
        branchData: action.payload,
      };
    }
    case types.FETCH_SINGLE_BRANCH_FAILED: {
      return {
        ...state,
        branchSingleDataStatus: false,
        branchData: null,
      };
    }
    case types.FETCH_BRANCH_USER:
      return {
        ...state,
        branchUserDataStatus: true,
        branchUserData: null,
      };
    case types.FETCH_BRANCH_USER_SUCCESS: {
      return {
        ...state,
        branchUserDataStatus: false,
        branchUserData: action.payload,
      };
    }
    case types.FETCH_BRANCH_USER_FAILED: {
      return {
        ...state,
        branchUserDataStatus: false,
        branchUserData: null,
      };
    }

    case types.FETCH_COUNTRY_BRANCH:
      return {
        ...state,
        countryBranchStatus: true,
        countriesBranch: [],
      };
    case types.FETCH_COUNTRY_BRANCH_SUCCESS: {
      return {
        ...state,
        countryBranchStatus: false,
        countriesBranch: action.payload,
      };
    }
    case types.FETCH_COUNTRY_BRANCH_FAILED: {
      return {
        ...state,
        countryBranchStatus: false,
        countriesBranch: [],
      };
    }

    case types.FETCH_STATE_BRANCH:
      return {
        ...state,
        stateBranchStatus: true,
        statesBranch: [],
      };
    case types.FETCH_STATE_BRANCHSUCCESS: {
      return {
        ...state,
        stateBranchStatus: false,
        statesBranch: action.payload,
      };
    }
    case types.FETCH_STATE_BRANCHFAILED: {
      return {
        ...state,
        stateBranchStatus: false,
        statesBranch: [],
      };
    }

    case types.FETCH_CITY_BRANCH:
      return {
        ...state,
        cityBranchStatus: true,
        citiesBranch: [],
      };
    case types.FETCH_CITY_BRANCHSUCCESS: {
      return {
        ...state,
        cityBranchStatus: false,
        citiesBranch: action.payload,
      };
    }
    case types.FETCH_CITY_BRANCHFAILED: {
      return {
        ...state,
        cityBranchStatus: false,
        citiesBranch: [],
      };
    }

    case types.DELETE_BRANCH:
      return {
        ...state,
        deleteBranchStatus: true,
      };
    case types.DELETE_BRANCH_SUCCESS: {
      return {
        ...state,
        deleteBranchStatus: false,
      };
    }
    case types.DELETE_BRANCH_FAILED: {
      return {
        ...state,
        deleteBranchStatus: false,
      };
    }

    case types.CREATE_TESTIMONIAL:
      return {
        ...state,
        creatingTestimonialStatus: true,
      };
    case types.CREATE_TESTIMONIAL_SUCCESS: {
      return {
        ...state,
        creatingTestimonialStatus: false,
      };
    }
    case types.CREATE_TESTIMONIAL_FAILED: {
      return {
        ...state,
        creatingTestimonialStatus: false,
      };
    }

    case types.FETCH_APPLIED_BRANCH:
      return {
        ...state,
        appliedBranchStatus: true,
        appliedBranch: [],
      };
    case types.FETCH_APPLIED_BRANCH_SUCCESS: {
      return {
        ...state,
        appliedBranchStatus: false,
        appliedBranch: action.payload,
      };
    }
    case types.FETCH_APPLIED_BRANCH_FAILED: {
      return {
        ...state,
        appliedBranchStatus: false,
        appliedBranch: [],
      };
    }

    case types.CREATE_APPLIED_BRANCH:
      return {
        ...state,
        createAppliedBranchStatus: true,
      };
    case types.CREATE_APPLIED_BRANCH_SUCCESS: {
      return {
        ...state,
        createAppliedBranchStatus: false,
      };
    }
    case types.CREATE_APPLIED_BRANCH_FAILED: {
      return {
        ...state,
        createAppliedBranchStatus: false,
      };
    }

    case types.UPDATE_APPLIED_BRANCH:
      return {
        ...state,
        updateAppliedBranchStatus: true,
      };
    case types.UPDATE_APPLIED_BRANCH_SUCCESS: {
      return {
        ...state,
        updateAppliedBranchStatus: false,
      };
    }
    case types.UPDATE_APPLIED_BRANCH_FAILED: {
      return {
        ...state,
        updateAppliedBranchStatus: false,
      };
    }

    case types.CHANGE_MODERATION_STATUS:
      return {
        ...state,
        moderationStatus: true,
      };
    case types.CHANGE_MODERATION_STATUS_SUCCESS: {
      return {
        ...state,
        moderationStatus: false,
      };
    }
    case types.CHANGE_MODERATION_STATUS_FAILED: {
      return {
        ...state,
        moderationStatus: false,
      };
    }

    case types.FETCH_DEALER_PROFILE:
      return {
        ...state,
        dealerProfileStatus: true,
        dealerProfile: null,
      };
    case types.FETCH_DEALER_PROFILE_SUCCESS: {
      return {
        ...state,
        dealerProfileStatus: false,
        dealerProfile: action.payload,
      };
    }
    case types.FETCH_DEALER_PROFILE_FAILED: {
      return {
        ...state,
        dealerProfileStatus: false,
        dealerProfile: null,
      };
    }
    case types.CLEAR_PREVIOUS_REDUCERS:
      return {
        ...state,
        branchData: null,
        branches: [],
        branchCount: 0,
      };
    case types.SET_UPDATE_BUTTON_CLICK_PLACE:
      return {
        ...state,
        updateButtonClickPlace: action.payload,
      };

    default:
      return state;
  }
}

export default branchReducer;
